import { render, staticRenderFns } from "./UnitPlanStandardsSelectFieldAlt1.vue?vue&type=template&id=d38c50e6&"
import script from "./UnitPlanStandardsSelectFieldAlt1.vue?vue&type=script&lang=js&"
export * from "./UnitPlanStandardsSelectFieldAlt1.vue?vue&type=script&lang=js&"
import style0 from "./UnitPlanStandardsSelectFieldAlt1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d38c50e6', component.options)
    } else {
      api.reload('d38c50e6', component.options)
    }
    module.hot.accept("./UnitPlanStandardsSelectFieldAlt1.vue?vue&type=template&id=d38c50e6&", function () {
      api.rerender('d38c50e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitPlanStandardsSelectFieldAlt1.vue"
export default component.exports